import React from "react";
import { cutoffs, colors } from "./PerformanceSummary";
import SingleEvent from "./SingleEvent";
import { StructureName } from "../types/all-game-data/Enums";
import { JungleCampName } from "../types/snapshot/Enums";
var EventCard = function (_a) {
    var gameData = _a.gameData, aggEvent = _a.aggEvent, championSummary = _a.championSummary;
    if (!gameData || !aggEvent) {
        return null;
    }
    var totalDiff = aggEvent.reduce(function (acc, event) { return acc + event.winrateDiff; }, 0);
    var diff = totalDiff > 0 ? "+".concat(totalDiff.toFixed(2), "%") : "".concat(totalDiff.toFixed(2), "%");
    var color = colors[cutoffs.findIndex(function (cutoff) { return totalDiff >= cutoff; })];
    var minutes = Math.floor(aggEvent[0].time / 60);
    var seconds = Math.floor(aggEvent[0].time % 60);
    var time = "".concat(minutes, ":").concat(seconds < 10 ? '0' : '').concat(seconds);
    var title;
    if (aggEvent.find(function (event) { return event.victimName === JungleCampName.BARON; })) {
        title = aggEvent.length === 1 ? 'Baron' : 'Baron Fight';
    }
    else if (aggEvent.find(function (event) { return event.victimName.endsWith('dragon'); })) {
        title = aggEvent.length === 1 ? 'Dragon' : 'Dragon Fight';
    }
    else if (aggEvent.find(function (event) { return event.victimName === JungleCampName.RIFT_HERALD; })) {
        title = aggEvent.length === 1 ? 'Herald' : 'Herald Fight';
    }
    else if (aggEvent.find(function (event) { return event.victimName === JungleCampName.GRUB_1 || event.victimName === JungleCampName.GRUB_2 || event.victimName === JungleCampName.GRUB_3; })) {
        var numGrubsTaken = aggEvent.filter(function (event) { return event.victimName === JungleCampName.GRUB_1 || event.victimName === JungleCampName.GRUB_2 || event.victimName === JungleCampName.GRUB_3; }).length;
        title = aggEvent.length > numGrubsTaken ? 'Grubby Fight' : (numGrubsTaken > 1 ? 'Grubbies' : 'Grubby');
    }
    else {
        var allyParticipants_1 = new Set();
        var enemyParticipants_1 = new Set();
        var championKills_1 = 0;
        aggEvent.forEach(function (event) {
            event.participantChampionNames.forEach(function (championName) {
                if (Object.values(gameData.allyRoles).includes(championName) && event.participantTeam === gameData.playerTeam) {
                    allyParticipants_1.add(championName);
                }
                else if (Object.values(gameData.enemyRoles).includes(championName) && event.participantTeam !== gameData.playerTeam) {
                    enemyParticipants_1.add(championName);
                }
            });
            if (Object.values(gameData.allyRoles).includes(event.victimName) && event.victimTeam === gameData.playerTeam) {
                allyParticipants_1.add(event.victimName);
                championKills_1 += 1;
            }
            else if (Object.values(gameData.enemyRoles).includes(event.victimName) && event.victimTeam !== gameData.playerTeam) {
                enemyParticipants_1.add(event.victimName);
                championKills_1 += 1;
            }
        });
        if (allyParticipants_1.size + enemyParticipants_1.size >= 7 && championKills_1 >= 1) {
            title = 'Teamfight';
        }
        else if (allyParticipants_1.size + enemyParticipants_1.size >= 3 && championKills_1 >= 2) {
            title = 'Skirmish';
        }
        else if (championKills_1 >= 1) {
            title = 'Takedown';
        }
        else if (aggEvent.find(function (event) { return StructureName.isInhib(event.victimName); })) {
            title = 'Inhib Takedown';
        }
        else if (aggEvent.find(function (event) { return StructureName.isTurret(event.victimName); })) {
            title = 'Tower Takedown';
        }
        else {
            title = 'Takedown'; // placeholder, hopefully never gets here
        }
    }
    var boxShadow = "inset 0 0 15px ".concat(color, "88, inset 0 0 30px ").concat(color, "44, inset 0 0 45px ").concat(color, "22");
    var boxShadowHover = "0 0 3px 2px white, inset 0 0 15px ".concat(color, "88, inset 0 0 30px ").concat(color, "44, inset 0 0 45px ").concat(color, "22");
    return (React.createElement("div", { style: {
            width: 350,
            height: 285,
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            border: "2px solid ".concat(color),
            borderRadius: 4,
            boxShadow: boxShadow,
            cursor: 'pointer',
            transition: 'box-shadow 0.3s ease',
        }, onMouseEnter: function (e) {
            e.currentTarget.style.boxShadow = boxShadowHover;
        }, onMouseLeave: function (e) {
            e.currentTarget.style.boxShadow = boxShadow;
        } },
        React.createElement("div", { style: { position: 'relative', width: '100%', flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' } },
            React.createElement("div", { style: { position: 'absolute', left: 20, top: '50%', transform: 'translateY(-50%)', fontWeight: 600 } }, time),
            React.createElement("div", { style: { fontSize: 20, fontWeight: 600 } }, title),
            React.createElement("div", { style: { position: 'absolute', right: 20, top: '50%', color: color, transform: 'translateY(-50%)', fontWeight: 600 } }, diff)),
        React.createElement("div", { style: { width: '100%', flex: 4, display: 'flex', flexDirection: 'column', marginTop: 20, paddingBottom: 20, overflowY: 'scroll', overflowX: 'hidden' } }, aggEvent.map(function (event, i) { return (React.createElement(SingleEvent, { key: i, gameData: gameData, event: event, championSummary: championSummary })); }))));
};
export default EventCard;
